import { Navigate, Outlet } from 'react-router-dom';

import { prependBasename } from '@lib/core/service/utils';
import { useUserKiosk } from '@lib/core/users/hooks/useUserKiosk';
import { PAGES } from '@lib/tools/views/urls';

export const KioskRoutes = () => {
  const { isUserKioskAdmin } = useUserKiosk();

  return isUserKioskAdmin ? <Outlet /> : <Navigate replace to={PAGES.vinhood.kioskLogin} />;
};

export const AnonRoutes = () => {
  const { isUserKioskAdmin } = useUserKiosk();

  return isUserKioskAdmin ? <Navigate replace to={prependBasename(PAGES.vinhood.welcome)} /> : <Outlet />;
};

export const KioskCatchAll = () => {
  const { isUserKioskAdmin } = useUserKiosk();

  return <Navigate replace to={isUserKioskAdmin ? prependBasename(PAGES.vinhood.welcome) : PAGES.vinhood.kioskLogin} />;
};
